import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SingleDepartmentService } from '../../../shared/services/single-department.service';

@Injectable({
  providedIn: 'root',
})
export class PackingTrackerDepartmentService extends SingleDepartmentService {
  protected readonly router = inject(Router);
  readonly NAME = 'Packing Tracker';
  defaultRoutes(roles: string[]): boolean {
    if (
      roles.includes('PackingTrackerChief') ||
      roles.includes('PackingTrackerOperator') ||
      roles.includes('PackingTrackerLeader') ||
      roles.includes('PackingTrackerViewer')
    ) {
      this.router.navigate(['/sb/packing-tracker/info']);
      return true;
    }
    return false;
  }
}
